module.exports = __webpack_public_path__ + "static/media/college-algebra-enrolled.dd7a6938.svg";